import type { FC, MouseEventHandler, TouchEventHandler } from "react";
import styles from "./ProgressBar.module.css";

interface ProgressBarProps {
  boundaryRef: React.RefObject<HTMLDivElement>;
  progress: number;
  onCircleMouseDown: MouseEventHandler<HTMLButtonElement>;
  onCircleTouchStart: TouchEventHandler<HTMLButtonElement>;
}

export const ProgressBar: FC<ProgressBarProps> = ({
  boundaryRef,
  progress,
  onCircleMouseDown,
  onCircleTouchStart,
}) => (
  <div
    ref={boundaryRef}
    className={styles.wrapper}
    style={{ ["--progress" as string]: `${progress}%` }}
  >
    <div className={styles.backgroundBar}>
      <div className={styles.progressBar} />
    </div>
    <button
      className={styles.circleButton}
      type="button"
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={onCircleMouseDown}
      onTouchStart={onCircleTouchStart}
    />
  </div>
);
